import cover1 from "../assets/serene-images/ConstructionImages/IMAGE_12-2.jpg";
import cover2 from "../assets/serene-images/LiveImages/image13.jpeg";
import g1a from "../assets/serene-images/ConstructionImages/IMAGE_4-3.jpg";
import g1b from "../assets/serene-images/ConstructionImages/IMAGE_6-1.jpg";
import g1c from "../assets/serene-images/ConstructionImages/IMAGE_6-1 (1).jpg";
import g1d from "../assets/serene-images/ConstructionImages/IMAGE_8-2.jpg";
import g1e from "../assets/serene-images/ConstructionImages/IMAGE_11.jpg";
import g1f from "../assets/serene-images/ConstructionImages/IMAGE_12-2.jpg";
import g1g from "../assets/serene-images/ConstructionImages/IMAGE_14-3.jpg";
import g1h from "../assets/serene-images/ConstructionImages/IMAGE_17-1.jpg";
import g1i from "../assets/serene-images/ConstructionImages/IMAGE_17-2.jpg";
import g1j from "../assets/serene-images/ConstructionImages/IMAGE_23-1.jpg";
import VideoCover from "../assets/palms-images/palms-construction.avif";

export const palmsFeatures = [
  {
    title: "Construction Progress",
    cover: cover1,
    type: "folder",
    folders: [
      {
        title: "January 2026 Update",
        cover: g1a,
        gallery: [g1a, g1b, g1c, g1d, g1e],
      },
      {
        title: "February 2026 Update",
        cover: g1f,
        gallery: [g1f, g1g, g1h, g1i, g1j],
      }
    ]
  },
  {
    title: "Video Gallery",
    cover: VideoCover,
    type: "folder",
    folders: [
      {
        title: "January 2026 Update",
        cover: cover1,
        gallery: [
          { type: "video", src: "/Palms-Construction-Progress/Videos/Plams-January.mp4", title: "JANUARY 2026 UPDATE" }
        ],
      },
      {
        title: "February 2026 Update",
        cover: cover2,
        gallery: [
          { type: "video", src: "/Palms-Construction-Progress/Videos/Palms-February.mp4", title: "FEBRUARY 2026 UPDATE" }
        ],
      }
    ]
  },
];
